module.exports = __webpack_public_path__ + "img/diente-blanco.c2b1ec78.png";